export class HttpBodyReqPaginationGlobalVarModel {
	public pageSize: number;
	public pageNo: number;

	constructor() {
		this.pageSize = 3;
		this.pageNo = 1;
	}

	public convert(): any {
		return {
			pageSize: this.pageSize,
			pageNo: this.pageNo,
		};
	}
}
